import { render, staticRenderFns } from "./ManyToManyMatrix.vue?vue&type=template&id=37dc31dd"
import script from "./ManyToManyMatrix.vue?vue&type=script&lang=js"
export * from "./ManyToManyMatrix.vue?vue&type=script&lang=js"
import style0 from "./ManyToManyMatrix.vue?vue&type=style&index=0&id=37dc31dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports